import React, { useState } from 'react';
import { Card, Modal, Button, Form } from 'react-bootstrap';
import EnrollCommunityModal from '../FormModals/EnrollCommunityModal.tsx';
import { getAccount } from '@wagmi/core';
import EditParameterGroupModal from '../FormModals/EditParameterGroupModal.tsx';
import * as config from '../../config.tsx';
interface Props {
    group: any; // Group can be of any type, since the data may vary
    onClick?: () => void;
    isSelected: boolean;
    onEnrollClick: (groupName: string) => void;
}

const ParameterGroupCard: React.FC<Props> = ({ group, onClick, isSelected, onEnrollClick }) => {
    const [showDescription, setShowDescription] = useState(false);
    const [showEnrollModal, setShowEnrollModal] = useState(false);
    const [showEditlModal, setShowEditModal] = useState(false);
    const [decodedABI, setDecodedABI] = useState<string | null>(null);
    const [showABI, setShowABI] = useState(false);

    const account = getAccount(config.config);

    // Add a check for undefined group or unexpected format
    if (!group || group.length < 7) {
        return (
            <Card className="mb-3 shadow-sm" style={{ backgroundColor: '#343a40', color: '#ffffff', padding: '20px' }}>
                <Card.Body>
                    <Card.Title style={{ color: '#ff4d4f' }}>Invalid Parameter Group</Card.Title>
                    <Card.Text>Parameter group data is missing or corrupted.</Card.Text>
                </Card.Body>
            </Card>
        );
    }

    const handleEnrollButtonClick = (event: React.MouseEvent) => {
        event.stopPropagation(); // Prevent the card click event from being triggered
        setShowEnrollModal(true);
    };

    const handleEditButtonClick = (event: React.MouseEvent) => {
        event.stopPropagation(); // Prevent the card click event from being triggered
        setShowEditModal(true);
    };
    const handleABIClick = () => {
        try {
            // Decode the base64 encoded ABI using atob
            const decoded = atob(group[2]);
            setDecodedABI(decoded);
            setShowABI(true);
        } catch (error) {
            console.error('Failed to decode ABI:', error);
            setDecodedABI('Failed to decode ABI');
        }
    };

    return (
        <>
            <Card
                className={`mb-3 shadow-sm ${isSelected ? 'border-primary' : ''}`}
                onClick={onClick}
                style={{
                    cursor: onClick ? 'pointer' : 'default',
                    borderRadius: '10px',
                    backgroundColor: '#343a40',
                    color: '#ffffff',
                    transition: 'transform 0.2s ease-in-out',
                    padding: '20px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                    border: isSelected ? '2px solid #17a2b8' : 'none',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
            >
                <Card.Body>
                    <Card.Title className="mb-2" style={{ fontWeight: 'bold', color: '#17a2b8' }}>
                        {group[0]} <span className="badge badge-light">#{group[6]}</span>
                    </Card.Title>
                    <Card.Subtitle className="mb-3 text-muted">
                        <small>Contract Address:</small>
                        <br />
                        <span style={{ fontFamily: 'monospace', fontSize: '0.9em' }}>
                            {group[1]}
                        </span>
                    </Card.Subtitle>
                    <Card.Text className="mb-3" style={{ fontSize: '0.95em' }}>
                        <strong>Description:</strong>
                        {group[3].length > 200 ? (
                            <>
                                {group[3].slice(0, 200)}...
                                <Button
                                    variant="link"
                                    size="sm"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setShowDescription(true);
                                    }}
                                    style={{ padding: '0' }}
                                >
                                    Read more
                                </Button>
                            </>
                        ) : (
                            <>{group[3]}</>
                        )}
                    </Card.Text>
                    <Card.Text className="mb-3" style={{ fontSize: '0.95em' }}>
                        <strong>Owner:</strong>
                        <br />
                        <span style={{ fontFamily: 'monospace', fontSize: '0.9em' }}>
                            {group[4]}
                        </span>
                    </Card.Text>
                    <Card.Text className="mb-3" style={{ fontSize: '0.95em' }}>
                        <strong>Enrollments:</strong> {group[5].toString()}
                    </Card.Text>
                    <Card.Text
                        className="mb-3"
                        style={{
                            fontSize: '0.85em',
                            color: '#adb5bd',
                            cursor: 'pointer',
                            textDecoration: 'underline',
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleABIClick();
                        }}
                    >
                        <strong>Encoded ABI:</strong>
                        <br />
                        <span style={{ fontFamily: 'monospace', fontSize: '0.8em' }}>
                            {group[2].substring(0, 30)}...{/* Display first 30 chars */}
                        </span>
                    </Card.Text>
                    <Button variant="info" onClick={handleEnrollButtonClick}>
                        Enroll Community
                    </Button>
                    { group[4] == account.address &&

                    <Button style={{marginTop:"10px"}}variant="outline-info" onClick={handleEditButtonClick}>
                        Edit Parameter Group
                    </Button>
                }
                </Card.Body>
            </Card>

            {/* Modal to show the full description */}
            <Modal show={showDescription} onHide={() => setShowDescription(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Description for {group[0]}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{group[3]}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDescription(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal to show the decoded ABI */}
            <Modal show={showABI} onHide={() => setShowABI(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Decoded ABI for {group[0]}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', backgroundColor: '#272b30', color: '#ffffff', padding: '15px', borderRadius: '5px' }}>
                        {decodedABI || 'Decoding...'}
                    </pre>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowABI(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <EditParameterGroupModal
                    show={showEditlModal}
                    onHide={() => setShowEditModal(false)}
                    pgName={group[0]}
            />

            {/* Enrollment Modal */}
            <EnrollCommunityModal
                show={showEnrollModal}
                onHide={() => setShowEnrollModal(false)}
                parameterGroupName={group[0]}
            />
        </>
    );
};

export default ParameterGroupCard;
